<template lang="pug">
  div.margin-top-5
    el-row(
      :gutter="20"
      v-for="(item, index) in itemList"
      :key="index"
    )
      el-form(
        :model="item"
        :rules="rules"
        ref="form-criteria"
      )
        el-col(:span="1") &nbsp;
        el-col(:span="8")
          el-form-item(prop="name")
            el-input(v-model="item.name" size="small" placeholder="Variable name")

        el-col(:span="4")
          el-form-item(prop="value")
            el-select(
              v-model="item.value" 
              size="small" 
              placeholder="Type")
              el-option(
                v-for="type in varTypes"
                :key="type"
                :label="type"
                :value="type"
              )
        el-col(:span="9" style="text-align: right")
          el-form-item(prop="score")
            span.margin-right-5 Pts
            el-input-number(
              v-model="item.score" 
              :step="1" 
              :min="0.01" 
              size="small")
            el-button(
              type="danger"
              size="small"
              icon="el-icon-delete"
              style="margin-left: 1vw"
              @click="removeItem(index)"
            )

    el-button.margin-top-20(
      type="primary"
      icon="el-icon-plus"
      size="mini"
      @click="addItem"
    ) Add Item



</template>

<script>
  import { MATLAB_VARIABLE_TYPES } from '@/defines/constants'

  export default {
    props: {
      itemList: {
        type: Array,
        required: true,
      },
    },

    data() {
      return {
        rules: {
          name: [
            {
              required: true,
              message: 'Name is required',
              trigger: 'blur',
            },
          ],
          value: [
            {
              required: true,
              message: 'Type is required',
              trigger: 'blur',
            },
          ],
          score: [
            {
              type: 'number',
              required: true,
              message: 'Score is required',
              trigger: 'blur',
            },
          ],
        },
      }
    },

    computed: {
      varTypes: () => MATLAB_VARIABLE_TYPES,
    },

    mounted() {
      if (!this.itemList.length) {
        this.addItem()
      }
    },

    methods: {
      addItem() {
        this.itemList.push({ name: '', score: 1 })
      },

      removeItem(index) {
        this.itemList.splice(index, 1)
      },

      validateAll() {
        let isValid = true
        for (const form of this.$refs['form-criteria']) {
          form.validate(valid => {
            isValid = isValid && valid
          })
        }
        return isValid
      },
    },
  }
</script>